import React from 'react';
import { COLORS, FONTS } from '../../../styles/tokens';
import NewOrderIcon from './NewOrderIcon';

// Ramme for «Nytt oppdrag»: topptekst med lukk-knapp, innhold og klistret CTA-felt nederst.
export default function NewOrderShell({ onClose, error, footer, step, children }) {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.titleRow}>
          <button type="button" onClick={onClose} aria-label="Lukk" style={styles.closeBtn}>
            <NewOrderIcon name="x" size={18} strokeWidth={2.2} />
          </button>
          <h2 style={styles.title}>Nytt oppdrag</h2>
        </div>

        {step && (
          <div style={styles.step} aria-live="polite">
            {`Steg ${step.current} av ${step.total} · ${step.title}`}
          </div>
        )}

        <div style={styles.body}>
          {children}
        </div>

        <div style={styles.ctaBar}>
          {error && <div role="alert" style={styles.error}>{error}</div>}
          <div style={{ display: 'flex', gap: 10 }}>{footer}</div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: { flex: 1, display: 'flex', justifyContent: 'center', padding: '16px 20px 0', paddingTop: 'max(24px, env(safe-area-inset-top))' },
  card: { width: '100%', maxWidth: 520, alignSelf: 'stretch', display: 'flex', flexDirection: 'column' },
  titleRow: { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 },
  title: { fontFamily: FONTS.display, fontSize: 26, fontWeight: 700, color: COLORS.textDark, margin: 0 },
  closeBtn: { width: 40, height: 40, borderRadius: '50%', border: `1px solid ${COLORS.border}`, background: COLORS.white, color: COLORS.textDark, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 },
  step: { fontSize: 13, fontWeight: 600, color: COLORS.textMid },
  body: { display: 'flex', flexDirection: 'column', gap: 10, flex: 1, paddingTop: 14, paddingBottom: 16 },
  error: { background: COLORS.dangerBg, color: COLORS.dangerText, padding: '11px 13px', borderRadius: 8, fontSize: 14 },
  ctaBar: { position: 'sticky', bottom: 0, display: 'flex', flexDirection: 'column', gap: 10, margin: '0 -20px', padding: '12px 20px max(16px, env(safe-area-inset-bottom))', background: COLORS.bg, borderTop: `1px solid ${COLORS.border}`, zIndex: 20 },
};

export const ctaStyles = {
  primary: { flex: 1, height: 52, borderRadius: 26, border: 'none', background: COLORS.accent, color: '#1a1a2e', fontSize: 16, fontWeight: 700, cursor: 'pointer' },
  hint: { flex: 1, minHeight: 52, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, color: COLORS.textMid, textAlign: 'center' },
  back: { width: 52, height: 52, borderRadius: '50%', border: `1.5px solid ${COLORS.brandPanel}`, background: 'transparent', color: COLORS.textDark, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', flexShrink: 0 },
};
